type Props = {
  visible: boolean;
};

export default function CarContractReminder({ visible }: Props) {
  if (!visible) return null;

  return (
    <div className="mx-4 mt-3 px-3 py-2.5 rounded-xl flex items-center gap-2 bg-white">
      <div
        className="px-3 py-2.5 rounded-xl flex items-center gap-2 w-full"
        style={{ background: "#E0F2FE", border: "1px solid #BAE6FD" }}
      >
        <i
          className="ri-information-line flex-shrink-0"
          style={{ color: "#0EA5E9", fontSize: 14 }}
        />
        <span className="text-xs font-medium" style={{ color: "#0EA5E9" }}>
          请尽快签署合同以确保出行安排
        </span>
      </div>
    </div>
  );
}
